export default {
  // 邮件
  email: {
    theme: 'theme',
    sender: 'addresser',
    time: 'time',
    addressee: 'addressee',
    inbox: 'Inbox',
    hasBeenSent: 'Has been sent',
    drafts: 'drafts',
    csPersonnel: 'carbon copy recipients',
    emailContent: 'email content',
    themeIsMustfill: 'Topic is required',
    senderIsMustfill: 'The sender is required',
    addresseeIsMustfill: 'The recipient is required',
    emailContentIsMustfill: 'The content of the email is required',
    inputEmailAddress: 'Enter email address',
    rightEmailAddress: 'Please enter the correct email address',
    copyTo: 'Cancel the cc',
    blindCarbonCopy: 'blind carbon copy',
    massTexting: 'A mass of single show',
    write: 'write',
    enclosure: 'enclosure',
    individual: 'individual',
    sendMail: 'send emails',
    recordContacts: 'correspondence',
    mailList: 'address list',
    deleted: 'deleted',
    dustbin: 'dustbin',
    label: 'label',
    mailSet: 'mail settings',
    bindTip: 'Please bind your mailbox first and use it only after binding.',
    bindMyEmail: 'Bind to my mailbox',
    messageSynchronizationSucceeded: 'Successfully synchronize third party mail',
    classify: 'classify',
    formName: 'Form name',
    permission: 'access permission',
    linkAddress: 'link address',
    QRcodeSharing: 'Scan the QR code and share with your friends',
    sigeCode: 'Sign in QR code',
    downloadCode: 'Download QR code',
    extendedLink: 'Extended link',
    formLinkTip:
      'Assign multiple link addresses to the same form to identify different data submission sources.',
    personalTemplate: 'Personal template',
    companyTemplate: 'The organization template',
    allCustomerCategories: 'Classification of all customers',
    notFollowedUpInSevenDay: '7 days not followed up',
    productionManage: 'production management',
    mailTemplate: 'email template',
    dataTemplate: 'data template',
    webLinkTemplate: 'WEB Link template',
    copied: 'Copied to clipboard',
    sign: 'sign in',
    pwdVisit: 'Password access',
    publicVisit: 'Open access',
    background: 'background',
    backgroundTip: 'Select set background',
    backgroundColor: 'background color',
    customColor: 'custom colors ',
    backgroundImage: 'Background picture',
    clickUpdate: 'Click on the upload',
    updateFileTip: 'Only JPG/PNG files can be uploaded, and no more than 500kb',
    pictureTile: 'Image tile',
    name: 'name',
    mailAddress: 'e-mail address',
    addTime: 'add time',
    selectOneData: 'Please select one piece of data',
    name_empty: 'The name cannot be empty',
    mailAddress_empty: 'Email address cannot be empty',
    mailAddress_error: 'The email address format is incorrect',
    markedRead: 'marked as read',
    unreadMark: 'mark as unread',
    urgentMail: 'urgent mail',
    regularMail: 'regular mail',
    draft: 'draft',
    partialSuccess: 'partial success',
    failInSend: 'fail to send',
    approvalAdopt: 'approve',
    approvalReject: 'Approval to dismiss',
    sendReadIsSend: 'Request to send "read receipt", whether to send',
    send: 'send',
    noSend: "Don't send",
    selectReminderTime: 'Select reminder time',
    remindYourselfOnly: 'Just remind yourself',
    timingTransmission: 'timed transmission',
    preview: 'preview',
    roughDraft: 'save a draft',
    deleteThoroughly: 'completely delete',
    secretAgent: 'Close to send people',
    addAttachments: 'add attachment',
    addAttachmentFromFileLibrary: 'Add attachments from the file library',
    insertMailTemplate: 'Insert mail template',
    insertModuleData: 'Insert module data',
    insertWebForm: 'inserted the WEB form',
    urgent: 'urgency',
    receiptRequired: 'Receipt Required',
    pureText: 'plain text',
    encryptMessage: 'Encrypt mail',
    useSignature: 'Use the signature',
    recentContacts: 'Recent Contacts',
    selectContacts: 'select contact',
    selectFromModules: 'select from the module',
    selectFromAddressBook: 'select from the address book',
    modular: 'module',
    regularMailTip: 'This message is a regular message that will be sent in',
    issue: 'send out',
    yymmddhhmm: 'year,month, day, hour, minute',
    sendTime: 'Sendtime',
    editTime: 'modify time',
    EmailWillBeSentTo: 'This email will be sent in',
    sendToOppositeEmail: 'Send it to the email address',
    selectAttachmentFromFileLibrary: 'Select attachments from the file library',
    areYouSure: 'are you sure',
    selectedMail: 'The selected mail?',
    mayPass: 'through',
    backgroundCustomLayout: 'Background - custom module - page layout',
    add: 'add',
    gotIt: 'Got it',
    copySuccess: 'Copy success',
    selectApprover: 'Select the approver',
    nextStep: 'the next step',
    approver: 'approver',
    adopt: 'pass',
    specifyNextApprover: 'Designate the next approver',
    selectMembers: 'Select members',
    CC: 'carbon copy',
    cancelSecretDelivery: 'Cancel secret transmission',
    cancelGroupReleaseSingleDisplay: 'Cancel group single display',
    mailboxFormatOutOfLimit: 'The mailbox format is out of bounds',
    reply: 'reply',
    wrote: 'wrote',
    forward: 'transpond',
    technologicalProcess: 'technological process',
    notSelectExpirationTime: 'Please do not select expired time',
    pleaseSelectContact: 'Please select the contact person',
    enterApprovalPhase:
      'Your email has entered the approval process, please check it in the approval module',
    successfulReply: 'Reply successful',
    forwardingSuccess: 'Forward success',
    mailCont0ent_error: 'Email content cannot be empty',
    theme_error: 'The theme cannot be empty',
    ddressee_empty: 'The recipient cannot be empty',
    sender_empty: 'The sender cannot be empty',
    approver_empty: 'The approver cannot be blank',
    chooseWhereAdd: 'Please select the location you want to add',
    mailboxDuplicate: 'The mailbox has been repeated.',
    renturn: 'return',
    replyAll: 'reply all',
    withAccessories: 'with attachments',
    rejection: 'rejection',
    moveTo: 'move to',
    rditSendAgain: 'Edit again send',
    markedAs: 'mark as',
    alreadRead: 'read',
    unread: 'unread',
    markAllRead: 'All are marked as read',
    mailFrom: 'emails from',
    myMail: 'I sent the email',
    seal: 'seal',
    sentMe: 'Sent to me',
    iSent: 'I send',
    deleteTip: 'Are you sure you want to delete the selected email completely?',
    selectActionItem: 'Select the options that need to be done',
    noMessagesSelected: 'Unselected mail',
    onlyOneDataSelected: 'Only one piece of data can be selected',
    exportMail: 'Export selected mail',
    altogether: 'altogether',
    notSpam: 'This is not spam',
    addBusinessCardSignature: 'Add business card signature',
    addTextSignature: 'Add a text signature',
    signatureTitle: 'Signature title',
    applicableAccount: 'apply to account',
    founder: 'founder',
    default: 'default',
    defaultSignature: 'The default signature',
    signatureTitle_empty: 'The signature header cannot be empty',
    applicableAccount_empty: 'The applicable account cannot be empty',
    businessCardStyle: 'Business card style',
    pleaseSelectAtLeastOneData: 'Please select at least one piece of data',
    dataSource: 'data source',
    templateName: 'The name of the template',
    private: 'privacy',
    public: 'public',
    modified: 'modifier',
    template: 'template',
    type: 'type',
    updateTemplate: 'upload template',
    description: 'description',
    sampleTemplateDownLoad: 'Sample template download',
    templateDeleteTip: 'Are you sure you want to delete this template',
    customTemplateName: 'Custom template name',
    salesManage: 'sales management',
    templateName_empty: 'The template name cannot be empty',
    tempCotent_empty: 'The template content cannot be empty',
    accountManage: 'account management',
    disributionRule: 'Receiving rules',
    signatureSet: 'The signature set',
    blackAndWhileList: 'blacklist and whitelist',
    labelSet: 'Label set',
    addRule: 'Add rules',
    ruleName: 'Rule name',
    ruleName_empty: 'Rule names cannot be empty',
    enable: 'status',
    enable_empty: 'The state cannot be empty',
    triggerEven: 'trigger event',
    triggerCondition: 'triggering condition',
    performOperation: 'operation executive',
    otherOperations: 'Other operating',
    receiving: 'Receive (temporarily stored in dustbins)',
    reject: 'Reject (delete directly)',
    moveTop: 'Moving to',
    autoReply: 'auto-response ',
    receivedMail: 'receive an e-mail ',
    contains: 'contain',
    notIncluded: 'Do not include',
    EQUALS: 'equal to',
    NEQUALS: 'unequal to',
    GREATER: 'greater than',
    LESS: 'less than',
    GREATERE: 'be equal or greater than',
    LESSE: 'less than or equal to',
    mailSize: 'Mail size',
    editRule: 'editing rule',
    addLabel: 'Add Label',
    editLabel: 'Edit the label',
    labelName: 'Label Name',
    labelName_empty: 'The label name cannot be empty',
    selectColor: 'selected Color',
    myName: 'my name',
    onlyOneDataCanAdded: 'Only one piece of data can be added at a time',
    black: 'blacklist',
    white: 'white list',
    as: 'as',
    addWhite: 'Add white list',
    addBlack: 'Add blacklist',
    115: '111111',
    inputTip: 'Please enter an email address or domain name suffix,this address will be rejected.',
    inputTip2: 'Please enter an email address or domain name suffix.',
    editAccount: 'Edit account',
    toAuthorize: 'To authorize',
    authorizeTip: 'The email address you are currently binding to is',
    authorizeTip2:
      'According to the requirements of netease mailbox, please come after the verification is passed',
    authorizeTip3: 'Authorize, otherwise you may not be able to receive mail',
    verifySuccess: 'verify successfully',
    cannotVerifyMultipleAccount: 'Cannot verify multiple accounts at the same time',
    addAccount: 'Add account',
    verify: 'verify',
    automaticCollectionTip:
      'New account binding will automatically receive the last three months of mail',
    OnlyIMAPProtocolSupported:
      'Only IMAP protocol is supported.If the post office already has this function, please do not check it',
    authorizeTip4: 'Synchronize mail from post office outbox to system outbox (IMAP protocol only)',
    synchronizationSentBoxes: 'Has the outbox been synchronized',
    sendSynchronization: 'Whether the dispatch is synchronized',
    encryptedTransmission: 'encryption transmission ',
    mustBeEmailAddress: 'Must be email address',
    authorization: 'authorization code ',
    authorization_empty: 'The authorization code cannot be empty',
    setAuthorization: 'Please get the service authorization code in the mailbox Settings',
    authorizeTip5: 'Please open POP3/SMTP in the mailbox to get the authorization code',
    set: 'set',
    account: 'account',
    servers: '【POP3/SMTP...serve】',
    getAuthorization: 'To open the service and get the authorization code',
    nickname: 'nickname',
    receivingServerType: 'Receiving server type',
    receivingServerType_empty: 'The receive server type cannot be null',
    receivingServer: 'Receiving server',
    receivingServer_empty: 'The recipient server type cannot be empty',
    port: 'port',
    port_empty: 'The port cannot be empty',
    outgoingServer: 'Sending server',
    outgoingServer_empty: 'The sending server type cannot be empty',
    synchronizationSentboxes: 'Has the outbox been synchronized',
    introduction:
      'Get through the third party mail function, send and receive emails no longer switch back and forth',
    mailQuery: 'query and pivot',
    mailProcess: 'process management',
    nodeAttribute: 'node attributes',
    nodeAttribute_empty: 'Please select the node',
    nodeName: 'node name',
    nodeNameNaxLength15: 'You can only type 15 characters',
    branchCondition: 'Branch conditions',
    setBranchCondition: 'Set the branching condition',
    terminationApprover: 'Termination approver',
    approverTip:
      'As long as the termination of the approver after the approval, the approval will no longer continue to flow up, the termination of the approver can choose more.',
    approvalWay: 'The examination and approval way',
    approvalTurn: 'In turn, the examination and approval',
    onceApproval: '(one time approval by approver in this link)',
    jointlySign: 'countersign',
    jointlySignTip:
      '(all approvers shall receive the approval at the same time, and the approval shall be deemed to be approved only with the consent of all approvers)',
    orSign: 'orSign',
    orSignTip:
      '(all approvers receive the approval at the same time, only one person can approve or reject it.)',
    originator: "originator's",
    throughMethod: 'by on means',
    thereIsDraftBox: 'A draft box exists and is sent manually by the sender',
    directToCustomer: 'Direct to the customer',
    over: 'over',
    start: 'start',
    dragAddNewNode: 'Drag and drop to add a new node',
    saving: 'Save in the...',
    mailData: 'Email data',
    deleteTip2: 'This action will delete the message permanently. Do you want to continue?',
    receipt: 'receipt',
    hairParts: 'shipment dispatch',
    templatePermission: 'Template permissions',
    templatePermissionNote:
      'Used to control the addition, editing, and deletion of organization and data templates in mail Settings.',
    templateManage: 'Template manager',
    addManage: 'add admin',

    email: 'email',
    refresh: 'refresh',
    synchronization: 'synchronization',
    synchronizationtimesetting: 'synchronization time setting',
    selectfromorganizationalstructure: 'Choose from the organizational structure',
    synchronizationtimesettingTip: 'New mail message synchronization time settings',
    synchronizationtimesettingTip2:
      'The system automatically goes to the third party to pull the new email information.',
    synchronousOption1: 'real time',
    synchronousOption2: '1 hour',
    synchronousOption3: 'No, pull according to fixed rules of the system',
    newmailshare: 'new mail sharing',
    mailshareTip:
      'This feature allows designated personnel to view the email exchanges of certain members.For example, the manager can check the email exchanges of subordinate members, and the director can check the email exchanges of all personnel.',
    sharesetting: 'sharing settings',
    closepreview: 'Close the preview',
    // 20210305
    tentatively: 'Tentative',
    scheduleoverdue: 'The schedule has expired',
    // 20210526
    bindemailremark:
      'The public sender mailbox of the system is used as the sender for sending emails in message push, workflow automation, approval process, and business process. The public mailbox usually includes customer service mailbox, service mailbox, and personnel mailbox.',
    emailAddress: 'Email address',
    bindEmail: 'Binding email',
    name_empty2: 'The name cannot be empty',
    port_error: 'The port format is incorrect',
    delAddressTip: 're you sure you want to delete this email address?'
  }
}
